import React, { useLayoutEffect, useState, useSyncExternalStore } from 'react';
import { createPortal } from 'react-dom';
import Caricamento from '../ui/Caricamento.gif';

// Registro dei Loading montati: se ne sono attivi più di uno, mostriamo un solo overlay
let owners: symbol[] = [];
const listeners = new Set<() => void>();
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
const getFirstOwner = () => owners[0];
const notify = () => listeners.forEach((listener) => listener());

const Loading = () => {
  const [id] = useState(() => Symbol('loading'));
  const firstOwner = useSyncExternalStore(subscribe, getFirstOwner);

  useLayoutEffect(() => {
    owners = [...owners, id];
    notify();
    return () => {
      owners = owners.filter((owner) => owner !== id);
      notify();
    };
  }, [id]);

  if (firstOwner !== id) return null;

  // Portal sul body: copre tutto lo schermo anche se renderizzato dentro una modale (che usa transform)
  return createPortal(
    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 backdrop-blur-md z-[10000]">
      <img src={Caricamento} alt="Caricamento" className="w-100 h-48" />
    </div>,
    document.body
  );
};

export default Loading;
